import { Text, Box } from '@chakra-ui/react';
import DataTableCard from './DataTableCard';
import { useBinderCardColors } from '../hooks/useBinderCardColors';
import { formatSimpleValue } from '../utils/fieldFormatting';
import ValidationBadge from './ValidationBadge';

interface GraduatedLicensingCardProps {
  data?: any;
}

const GraduatedLicensingCard = ({ data }: GraduatedLicensingCardProps) => {
  const colors = useBinderCardColors();

  // Get processed data
  const drivers = data?.driverRows || [];

  const formatDate = (dateString: string) => {
    if (!dateString || dateString.trim() === '') {
      return (
        <Text color="gray.400" fontStyle="italic" fontSize="sm">
          Not provided
        </Text>
      );
    }
    return formatSimpleValue(dateString);
  };

  // Create table rows from processed driver data
  const driverRows = drivers.map((driver: any) => {
    return [
      driver.driverName || (
        <Text color="gray.400" fontStyle="italic" fontSize="sm">
          Not provided
        </Text>
      ),
      formatDate(driver.mvrIssueDate),
      formatDate(driver.quoteG1Date),
      driver.remarks ? (
        <Text fontSize="sm">{formatSimpleValue(driver.remarks)}</Text>
      ) : (
        <Text color="gray.400" fontStyle="italic" fontSize="sm">
          No remarks
        </Text>
      ),
      <ValidationBadge status={driver.isValid ? 'pass' : 'caution'} />,
    ];
  });

  const headers = [
    'Driver',
    'Issue Date (MVR)',
    'Date G1 (Quote)',
    'Remarks',
    'Outcome',
  ];

  // Handle empty state
  if (driverRows.length === 0) {
    return (
      <Box p={4} borderRadius="md" bg={colors.emptyFieldBgColor}>
        <Text color="gray.500" fontStyle="italic" textAlign="center">
          No driver data available
        </Text>
      </Box>
    );
  }

  return (
    <DataTableCard
      description="Check to ensure that the graduated licensing date is correct."
      headers={headers}
      rows={driverRows}
    />
  );
};

export default GraduatedLicensingCard;
